export default "__VITE_ASSET__B_Ta29oX__"